import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { HintStimulusModel } from "../../../../scripts/_generated/HintStimulusModel";
import { StimulusControllers } from "../../../../scripts/_generated/StimulusControllers";
import HintPopupController from "../HintPopup/HintPopupController";

export default class HintController extends BaseStimulusModelController<HintStimulusModel> {
    static targets = [
        "hintPopupTrigger"
    ];

    readonly hintPopupTriggerTarget!: HTMLElement;

    hintPopupController!: HintPopupController;

    connect() {
        this.hintPopupController = this.getHintPopupController();
    }

    openPopup(e: Event) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.hintPopupController.createAndShowPopper(this.hintPopupTriggerTarget, this.modelValue.popupHtmlContent);
    }

    private getHintPopupController(): HintPopupController {
        const hintPopupElement = document.querySelectorAll(`[data-controller='${StimulusControllers.hintPopup}']`);
        if (hintPopupElement.length === 0) throw new Error(`Cannot find ${StimulusControllers.hintPopup} controller element`)
        return this.application.getControllerForElementAndIdentifier(
            hintPopupElement[0],
            StimulusControllers.hintPopup
        ) as HintPopupController;
    }
}

